// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NavC_wrapper__33tMU","header":"NavC_header__3VT81","subHeader":"NavC_subHeader__1ERVK","seperator":"NavC_seperator__1gO9n","list":"NavC_list__Z7F9D"};